import * as _ from 'lodash'

import { CRUD, CrudModel } from '../../classes'
import { EpisodeData } from './episode.data'

@CRUD({
  base: '/crud/episodes',
})
export class EpisodeModel extends CrudModel {
  eid: string
  patientId: string

  constructor(data: EpisodeData) {
    super(data, true)
  }

  override toJSON(): any {
    return _.extend(super.toJSON(), {
      eid: this.eid,
      patientId: this.patientId,
    })
  }
}
